import {forkJoin, of} from 'rxjs';
// Angular
import {Injectable} from '@angular/core';
// RxJS
import {map, mergeMap, tap} from 'rxjs/operators';
// NGRX
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
// CRUD
import {QueryParamsModel, QueryResultsModel} from '../../_base/crud';
// Services
// State
import {AppState} from '../../../core/reducers';
// Actions
import {
    LeaderLevelActionTypes,
    LeaderLevelCreated,
    LeaderLevelOnServerCreated,
    LeaderLevelsPageLoaded,
    LeaderLevelsPageRequested,
    LeaderLevelsPageToggleLoading,
    LeaderLevelUpdated,
    OneLeaderLevelDeleted
} from '../_actions/leader-level.actions';
import {LeaderLevelService} from '../_services/leader-level.service';

@Injectable()
export class LeaderLevelEffects {
    showPageLoadingDistpatcher = new LeaderLevelsPageToggleLoading({isLoading: true});
    showLoadingDistpatcher = new LeaderLevelsPageToggleLoading({isLoading: true});
    hideActionLoadingDistpatcher = new LeaderLevelsPageToggleLoading({isLoading: false});

    @Effect()
    loadLeaderLevelsPage$ = this.actions$
        .pipe(
            ofType<LeaderLevelsPageRequested>(LeaderLevelActionTypes.LeaderLevelsPageRequested),
            mergeMap(({payload}) => {
                this.store.dispatch(this.showPageLoadingDistpatcher);
                const requestToServer = this.leaderLevelsService.findLeaderLevels(payload.page);
                const lastQuery = of(payload.page);
                return forkJoin(requestToServer, lastQuery);
            }),
            map(response => {
                const result: QueryResultsModel = response[0];
                const lastQuery: QueryParamsModel = response[1];
                return new LeaderLevelsPageLoaded({
                    leaderLevels: result.items,
                    totalCount: result.totalCount,
                    page: lastQuery
                });
            }),
        );

    @Effect()
    deleteLeaderLevel$ = this.actions$
        .pipe(
            ofType<OneLeaderLevelDeleted>(LeaderLevelActionTypes.OneLeaderLevelDeleted),
            mergeMap(({payload}) => {
                    this.store.dispatch(this.showLoadingDistpatcher);
                    return this.leaderLevelsService.deleteLeaderLevel(payload.id);
                }
            ),
            map(() => {
                return this.hideActionLoadingDistpatcher;
            }),
        );

    @Effect()
    updateLeaderLevel$ = this.actions$
        .pipe(
            ofType<LeaderLevelUpdated>(LeaderLevelActionTypes.LeaderLevelUpdated),
            mergeMap(({payload}) => {
                this.store.dispatch(this.showLoadingDistpatcher);
                return this.leaderLevelsService.updateLeaderLevel(payload.leaderLevel);
            }),
            map(() => {
                return this.hideActionLoadingDistpatcher;
            }),
        );

    @Effect()
    createLeaderLevel$ = this.actions$
        .pipe(
            ofType<LeaderLevelOnServerCreated>(LeaderLevelActionTypes.LeaderLevelOnServerCreated),
            mergeMap(({payload}) => {
                this.store.dispatch(this.showLoadingDistpatcher);
                return this.leaderLevelsService.createLeaderLevel(payload.leaderLevel).pipe(
                    tap(res => {
                        this.store.dispatch(new LeaderLevelCreated({leaderLevel: res}));
                    })
                );
            }),
            map(() => {
                return this.hideActionLoadingDistpatcher;
            }),
        );

    // @Effect()
    // init$: Observable<Action> = defer(() => {
    //     const queryParams = new QueryParamsModel({});
    //     return of(new LeaderLevelsPageRequested({ page: queryParams }));
    // });

    constructor(private actions$: Actions, private leaderLevelsService: LeaderLevelService, private store: Store<AppState>) {
    }
}
